import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { Reducer } from 'redux';

export default (reducers: Reducer) => {
  const persistedReducers = persistReducer(
    {
      key: 'app_vendas',
      storage,
      whitelist: ['user', 'category', 'sideMenuReducer'],
    },
    reducers,
  );
  return persistedReducers;
};
